import { render, staticRenderFns } from "./AddDynamicWidgetModal.vue?vue&type=template&id=29b11f56"
import script from "./AddDynamicWidgetModal.vue?vue&type=script&lang=js"
export * from "./AddDynamicWidgetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports